import { TFunction } from 'i18next';
import { FXCurrencies, type FXPayment } from 'types/operations';

import type { CardConfig } from '../types';

const hasFullBankAddress = [FXCurrencies.AUD, FXCurrencies.CAD];

const hasOnlyAddressLine = [
	FXCurrencies.DKK,
	FXCurrencies.GBP,
	FXCurrencies.CZK,
	FXCurrencies.HUF,
	FXCurrencies.ILS,
	FXCurrencies.NZD,
	FXCurrencies.NOK,
	FXCurrencies.PLN,
	FXCurrencies.RON,
	FXCurrencies.SGD,
	FXCurrencies.SEK,
	FXCurrencies.CHF,
	FXCurrencies.USD,
];

export const getFXAdditionalDetailsCard = (
	operation: FXPayment,
	t: TFunction,
): CardConfig => ({
	title: t('additionalDetails.title'),
	groups: [
		{
			title: t('additionalDetails.beneficiaryAddress'),
			fields: [
				{
					title: t('common.country'),
					content: operation?.beneficiary?.address?.country,
				},
				{
					title: t('common.city'),
					content: operation?.beneficiary?.address?.town,
				},
				{
					title: t('common.street'),
					content: operation?.beneficiary?.address?.line,
				},
				{
					title: t('common.buildingNumber'),
					content: operation?.beneficiary?.address?.building_number,
				},
				{
					title: t('common.postalCode'),
					content: operation?.beneficiary?.address?.postal_code,
				},
			],
		},
		{
			title: t('additionalDetails.beneficiaryBank'),
			fields: [
				{
					title: t('additionalDetails.bicCode'),
					content: operation?.beneficiary?.bank?.bic,
				},
				{
					title: t('additionalDetails.bankRoutingCode'),
					content: operation?.beneficiary?.bank_routing_number,
				},
				{
					title: t('additionalDetails.bankName'),
					content: operation?.beneficiary?.bank?.name,
				},
				{
					title: t('common.country'),
					content: operation?.beneficiary?.bank?.address?.country,
				},

				...(hasFullBankAddress.includes(operation?.fx_quote.currency_to ?? '')
					? [
							{
								title: t('common.city'),
								content: operation?.beneficiary?.bank?.address?.town,
							},
							{
								title: t('common.street'),
								content: operation?.beneficiary?.bank?.address?.line,
							},
							{
								title: t('common.buildingNumber'),
								content: operation?.beneficiary?.bank?.address?.building_number,
							},
							{
								title: t('common.postalCode'),
								content: operation?.beneficiary?.bank?.address?.postal_code,
							},
						]
					: []),

				...(hasOnlyAddressLine.includes(operation?.fx_quote.currency_to ?? '')
					? [
							{
								title: t('common.address'),
								content: operation?.beneficiary?.bank?.address?.line,
							},
						]
					: []),
			],
		},
	],
});
